<template>
  <div class="niche-overview">
    <div class="piece-box niche-overview-top">
      <div
        class="niche-overview-item"
        :class="{ link: d.route }"
        v-for="(d, i) in overviewData"
        :key="i"
        @click="clickItem(d)"
      >
        <div class="niche-overview-title">
          <span>{{ d.title }}</span>
          <a-popover v-if="d.tip">
            <template slot="content">
              <span style="color: #666; cursor: default">{{ d.tip }}</span>
            </template>
            <a-icon type="question-circle" class="tip-icon" />
          </a-popover>
        </div>
        <div class="niche-overview-num">{{ d.num }}</div>
      </div>
    </div>
    <div class="piece-box niche-select-area">
      <OverviewContent
        class="content-wrapper"
        :region-list="regionList"
        v-model="regionId"
        :loading="regionLoading"
        @input="getBlockList"
        v-show="step == 1"
        @select="step = 2"
      />
      <div class="content-wrapper flex-box vertical" v-show="step == 2">
        <BlockList
          :region-list="regionList"
          :region-id.sync="regionId"
          v-model="blockId"
          :block-list="blockList"
          :loading="blockLoading"
          class="content-wrapper"
          @selectRegion="getBlockList"
          @selectBlock="selectBlock"
        />
        <div class="block-bottom">
          <a-button type="primary" @click="prev">上一步</a-button>
        </div>
      </div>
      <div class="content-wrapper flex-box vertical" v-show="step == 3">
        <div class="data-title">
          <div class="title-left flex-box">
            <div class="niche-eg-item">
              <div class="niche-eg-icon"></div>
              <div class="niche-eg-title">不可选</div>
            </div>
            <div class="niche-eg-item">
              <div class="niche-eg-icon"></div>
              <div class="niche-eg-title">可选</div>
            </div>
            <div class="niche-eg-item">
              <!-- <div class="niche-eg-icon"></div> -->
              <div class="niche-eg-title" style="margin-left: 20px">
                供奉情况：
              </div>
            </div>
            <div class="niche-eg-item">
              <!-- <div class="niche-eg-icon"></div> -->
              <div class="niche-eg-title">已供（{{ available }}）</div>
            </div>
            <div class="niche-eg-item">
              <!-- <div class="niche-eg-icon"></div> -->
              <div class="niche-eg-title">可供（{{ provided }}）</div>
            </div>
            <a-button
              type="link"
              class="back-btn"
              @click="back"
              v-show="step == 3"
            >
              返回上级
            </a-button>
          </div>
          <a-form-model class="query-form" layout="inline">
            <a-form-model-item label="区域">
              <a-select
                style="width: 120px"
                placeholder="选择区域筛选"
                :options="regionList"
                v-model="regionId"
                disabled
              >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="区块">
              <a-select
                style="width: 120px"
                placeholder="选择区块筛选"
                :options="blockList"
                v-model="blockId"
                @change="getNicheList"
                disabled
              >
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="龛位编号" v-if="showSearch">
              <remote-search
                allow-clear
                v-model="num"
                url="/admin/memorial-tablet-block-item"
                :query="`&expand=tabletStatus&filter[is_open]=1&sort=num&filter[mem_tablet_block_id]=${blockId}`"
                name-key="num"
                placeholder="输入龛位编号搜索"
                style="width: 180px"
              >
                <template v-slot:title="{ option }">
                  {{ option.num }}
                </template>
              </remote-search>
            </a-form-model-item>
          </a-form-model>
        </div>
        <BlockArea
          :list="showBlockList"
          single
          v-model="nicheId"
          :loading="nicheLoading"
          :tablet-icon="block?.tabletIcon"
          class="content-wrapper"
        />
      </div>
      <div class="niche-select-bottom" v-if="select">
        <div class="flex-box align-center">
          <span>已选</span>
          <div class="niche-select-info">
            <span>
              {{ select.tabletBlock.tabletRegion.name }}-
              {{ select.tabletBlock.name }}-{{ select.num }}
            </span>
            <a-icon
              type="close"
              class="niche-select-remove"
              @click="removeSelect"
            />
          </div>
          <div class="niche-select-state">{{ select.statusText }}</div>
        </div>
        <a-space>
          <a-button @click="goNicheDetail">供奉信息</a-button>
          <a-button
            type="primary"
            @click="goTablet"
            :disabled="select.disabled || !!select.tabletStatus"
          >
            供奉
          </a-button>
        </a-space>
      </div>
    </div>
  </div>
</template>

<script>
import OverviewContent from "./components/OverviewContent.vue";
import BlockList from "./components/BlockList.vue";
import BlockArea from "./components/BlockArea.vue";
import { createBaseBlock } from "../../common/tablet/block";
import { clone } from "../../common/js/tool";
import { dealNiche } from "../../common/tablet/type";
import { Empty } from "ant-design-vue";

export default {
  name: "TabletNicheOverview",
  components: {
    OverviewContent,
    BlockList,
    BlockArea,
  },
  data() {
    return {
      overviewData: [
        { title: "龛位总数", num: 4032 },
        {
          title: "已供奉",
          num: 0,
          route: { name: "TabletNiche", query: { status: 1 } },
        },
        {
          title: "即将到期",
          num: 0,
          tip: "统计倒计时还有三天的订单",
          route: { name: "TabletOrder", query: { expire_date: 3 } },
        },
        {
          title: "今日供奉",
          num: 0,
          route: { name: "TabletOrder", query: { today_order: 1 } },
        },
      ],
      // select: null,
      loading: true,
      step: 1,
      showSearch: true, // 是否可查询
      num: undefined, // 查询的编号
      list: null,
      originList: [],
      hasGetParams: false,

      regionId: undefined, // 区域id
      regionList: [], // 区域列表
      blockId: undefined, // 区块id
      blockList: [], // 区块列表
      nicheId: undefined, // 佛龛id
      nicheList: [], // 佛龛类表
      showBlockList: [], // 佛龛展示列表
      regionLoading: false,
      blockLoading: false,
      nicheLoading: false,
      emptyImage: Empty.PRESENTED_IMAGE_SIMPLE,
    };
  },
  computed: {
    available() {
      return this.nicheList.filter(
        (item) => item.blockId == this.blockId && item.tabletStatus
      ).length;
    },
    provided() {
      return this.nicheList.filter(
        (item) => item.blockId == this.blockId && !item.tabletStatus
      ).length;
    },
    // 选中区域
    region() {
      return this.regionList.find((item) => item.id == this.regionId);
    },
    // 选中区块
    block() {
      return this.blockList.find((item) => item.id == this.blockId);
    },
    // 选中龛位
    niche() {
      return this.nicheList.find((item) => item.id == this.nicheId);
    },
    select() {
      return this.niche;
    },
  },
  watch: {
    num(val) {
      if (val) {
        if (val.tabletStatus) {
          this.$message.warning("该佛龛已供奉，请选择其他佛龛");
          return;
        }
        this.nicheId = val.id;
      }
    },
  },
  // beforeRouteLeave(form, to, next) {
  //   const select = this.select;
  //   select && !select.worshipStatus && dispatchNicheLight(select, 2);
  //   next();
  // },
  async created() {
    this.getCount();
    this.getRegion();
  },
  methods: {
    getCount() {
      const url = "/admin/memorial-tablet-order/count";
      this.$axios(url).then((res) => {
        const overviewData = this.overviewData;
        overviewData[0].num = res.total_num || 0;
        overviewData[1].num = res.already_gf || 0;
        overviewData[2].num = res.due || 0;
        overviewData[3].num = res.today_gf || 0;
      });
    },
    // 获取区域列表
    getRegion() {
      if (this.regionLoading) return;
      this.regionLoading = true;
      return this.$axios({
        url: "/admin/memorial-tablet-region",
        method: "GET",
        params: { expand: "count", pageSize: 9999 },
        noTempleFilter: true,
      })
        .then((res) => {
          this.regionList = res.data.map((item) => ({
            ...item,
            label: item.name,
            value: item.id,
          }));
          // this.setParamsSelect();
        })
        .finally(() => {
          this.regionLoading = false;
        });
    },
    // 获取区块列表
    getBlockList() {
      if (this.regionId) {
        if (this.blockLoading) return;
        this.blockLoading = true;
        this.$axios({
          url: "/admin/memorial-tablet-block",
          method: "GET",
          params: {
            pageSize: 9999,
            expand: "tabletIcon,tabletBlockItem",
            "filter[mem_tablet_region_id]": this.regionId,
          },
        })
          .then((res) => {
            this.blockList = res.data.map((item) => ({
              ...item,
              label: item.name,
              value: item.id,
              disabled: item.is_open == 2,
            }));
          })
          .finally(() => {
            this.blockLoading = false;
          });
      }
    },
    selectBlock() {
      this.step = 3;
      this.getNicheList();
    },
    // 获取最大行列数
    getRowsAndCols(list = []) {
      const rows = list.map((item) => item.row);
      const cols = list.map((item) => item.cols);
      const maxRow = Math.max(...rows);
      const maxCols = Math.max(...cols);
      return { maxRow, maxCols };
    },
    // 获取龛位列表
    getNicheList() {
      if (this.blockId) {
        if (this.nicheLoading) return;
        this.nicheLoading = true;
        this.$axios({
          url: "/admin/memorial-tablet-block-item",
          method: "GET",
          params: {
            pageSize: 9999,
            expand: "tabletStatus,tabletBlock.tabletRegion",
            "filter[mem_tablet_block_id]": this.blockId,
          },
        })
          .then((res) => {
            const list = res.data;
            this.nicheList = clone(list);
            const { maxRow, maxCols } = this.getRowsAndCols(list);
            const baseBlockList = createBaseBlock(maxRow, maxCols);
            const bList = baseBlockList.map((line) => {
              return line.map(({ row, cols }) => {
                let item = {
                  row,
                  cols,
                  hidden: true,
                };
                const niche = this.nicheList.find(
                  (item) => item.row == row && item.cols == cols
                );
                if (niche) {
                  dealNiche(niche);
                  item = niche;
                }
                return item;
              });
            });
            this.showBlockList = bList;
          })
          .finally(() => {
            this.nicheLoading = false;
          });
      }
    },
    setParamsSelect() {
      const params = this.$route.params;
      if (params.id) {
        this.district_id = params.district;
      }
    },
    goNicheDetail() {
      const select = this.select;
      if (select) {
        this.$router.push({
          name: "TabletNicheDetail",
          params: { id: select.id },
        });
      }
    },
    goTablet() {
      const select = this.select;
      if (select) {
        this.$store.commit("setNiche", { ...select });
        this.$router.push({
          name: "TabletOrderCreate",
          query: { select: select.id },
        });
      }
    },
    removeSelect() {
      this.nicheId = undefined;
    },
    // 上一步
    prev() {
      this.step = 1;
      this.regionId = undefined;
    },
    // 返回上一级
    back() {
      this.step = 2;
      this.nicheId = undefined;
      this.blockId = undefined;
    },
    clickItem(d) {
      let route = d.route;
      if (route) {
        this.$router.push(route);
      }
    },
  },
};
</script>

<style lang="less">
.niche-overview {
  flex: none;
  display: flex;
  flex-direction: column;
  margin: @padding-md auto;
  width: 1200px;
}
.niche-overview-top {
  display: flex;
  padding: 20px;
}
.niche-overview-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: default;
  &.link {
    cursor: pointer;
  }
}
.niche-overview-title {
  font-size: 20px;
  font-weight: 600;
  .tip-icon {
    color: #ff4d4f;
    margin-left: 4px;
    cursor: pointer;
  }
}
.niche-overview-num {
  margin-top: 8px;
  font-size: 16px;
  color: @text-color-secondary;
}
.niche-select-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  min-height: 0;
}

.niche-select-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  height: 60px;
  border-top: 1px solid rgba(255, 140, 0, 0.1);
  color: #ff8c00;
  .niche-select-info {
    display: flex;
    align-items: center;
    margin-left: 16px;
    padding: 6px 12px;
    height: 32px;
    border-radius: 4px;
    background-color: #ff8c00;
    color: @white;
    line-height: 1;
    font-size: 16px;
  }
  .niche-select-remove {
    margin-left: 8px;
    color: @white;
    cursor: pointer;
  }
  .niche-select-state {
    margin-left: 8px;
    color: @text-color-secondary;
  }
}
.content-wrapper {
  flex: 1;
  min-height: 0;
}
.data-title {
  padding: 16px;
  border-bottom: 1px solid rgba(255, 140, 0, 0.1);
  .niche-eg-item {
    display: flex;
    align-items: center;
    &:first-of-type {
      margin-right: 16px;
      .niche-eg-icon {
        opacity: 0.5;
      }
    }
  }
  .niche-eg-icon {
    width: 20px;
    height: 22px;
    background: url(../../assets/light/niche.png) center / contain no-repeat;
  }
  .niche-eg-title {
    margin-left: 0.5em;
  }
}
.back-btn {
  margin-left: 24px;
}

.block-bottom {
  padding: 24px;
  display: flex;
  justify-content: flex-end;
}
.full-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
